import { FC } from 'react'

import LabelAndInfo from '../LabelAndInfo'
import { formatDayMonthDate } from '../../../utils'

export type CashFundDetailsProps = {
  paymentMethod: string
  createdAt: string
}

const CashFundDetails: FC<CashFundDetailsProps> = ({
  paymentMethod,
  createdAt,
}) => (
  <>
    <LabelAndInfo info={paymentMethod} label="Contribution sent via" />
    <LabelAndInfo info={formatDayMonthDate(createdAt)} label="Date sent" />
  </>
)

export default CashFundDetails
